import {datePlugin} from '@/core/plugins/dates';

export default function(date, {format, dateFormat} = {}) {
    if (!date || typeof date !== 'string') {
        return '';
    }

    return datePlugin(date, dateFormat || 'DD.MM.YYYY HH.mm.ss').format(format || 'DD.MM.YYYY');
}

export const maxDate = (date, format) => {
    return datePlugin().subtract(date, format).toDate();
};
